<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path fill="#3e2723" d="M16,17h16v18H16V17z" />
    <path fill="#c16e14" d="M19,28h10v15H19V28z" />
    <path
      fill="#e5852e"
      d="M33,16c0-7.635-18-4.971-18,0v7c0,4.971,4.028,9,9,9c4.971,0,9-4.029,9-9V16z"
    />
    <path
      fill="#795548"
      d="M23.875,6C17.8,6,9,9.119,9,29l7,5V21l12-7l4,5v15l6-6c0-4.025,0.201-20-10.125-20l-1-2H23.875z"
    />
    <path
      fill="#212121"
      d="M27,23c0-0.551,0.448-1,1-1s1,0.449,1,1s-0.448,1-1,1S27,23.551,27,23 M19,23c0,0.551,0.448,1,1,1 s1-0.449,1-1s-0.448-1-1-1S19,22.449,19,23"
    />
    <path
      fill="#00acc1"
      d="M31.875,6c0,0-0.75-2-7.625-2c-6.874,0-8.375,2-8.375,2s-1,6-1,10c0,0,4.125-1,9.125-1 s8.875,1,8.875,1C32.875,12,31.875,6,31.875,6z M40,46H8c0-11.014,11-13,11-13v1l5,8l5-8v-1C29,33,40,35.025,40,46z"
    />
    <path
      fill="#37474f"
      d="M31.984,39.124c-0.126-3.667-0.996-6.324-1.05-6.482c-0.389-1.015-0.81-1.9-1.257-2.674 c-0.219,0.179-0.441,0.356-0.677,0.514v2.705c0.017,0.043,0.035,0.087,0.051,0.129c0.009,0.026,0.806,2.462,0.931,5.815 C27.654,39.75,27,42.474,27,44l2,0.003C29.001,43.88,29.042,41,31,41s1.999,2.88,2,3h2C35,42.466,34.339,39.726,31.984,39.124z M19,30.483c-0.146-0.098-0.28-0.213-0.42-0.319c-0.843,1.102-1.394,2.115-1.529,2.52C16.535,34.234,16,35.838,16,40 c0,0.552,0.448,1,1,1s1-0.448,1-1c0-3.838,0.461-5.22,0.949-6.684c0.011-0.033,0.032-0.08,0.051-0.124V30.483z"
    />
    <path
      fill="#263238"
      d="M17,39c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S18.657,39,17,39z"
    />
    <path
      fill="#cfd8dc"
      d="M29,46h-2v-2h2V46z M35,44h-2v2h2V44z M17,43c0.552,0,1-0.447,1-1s-0.448-1-1-1 c-0.553,0-1,0.447-1,1S16.447,43,17,43z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "DoctorFemaleIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
